module.exports = __webpack_public_path__ + "static/media/cubes-gold-02.e4cfe350.png";